import { render } from "./LicensesInfo.vue?vue&type=template&id=e608eb9a&scoped=true"
import script from "./LicensesInfo.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./LicensesInfo.vue?vue&type=script&charset=utf-8&lang=js"

import "./LicensesInfo.vue?vue&type=style&index=0&id=e608eb9a&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e608eb9a"]])

export default __exports__